<template>
  <div class="calligraphy">
    <!-- 遮罩层 -->
    <div class="mask"></div>
    <!--  书法-->
    <div v-show="status === 4" class="item">
      <div :class="['title', status === 4 ? 'animated fadeInUp' : '']">
        <div class="big">书法</div>
        <div class="small">写字+，不只是写字的书法课</div>
      </div>
      <div :class="['con', status === 4 ? 'animated fadeInUp' : '']">
        我们的书法课不仅是教孩子写几个漂亮字，而是通过“史窗书语、知识讲练、入木三分”三大板块，让孩子既能掌握汉字基本书写技法，明白规范字的书写要点，又能锻炼孩子的观察力、思考力和专注力，最后获得审美力，从技法和美育双层面，提升孩子书法水平。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['status']
};
</script>
<style lang="less">
.calligraphy {
  height: 100%;
  width: 100%;
  background: url(../../assets/images/calligraphy.png) center no-repeat;
  background-size: cover;
  position: relative;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 1);
    opacity: 0.6;
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }
  .item {
    position: relative;
    z-index: 2;
  }
  .title {
    animation-delay: 0.5s;
  }
  .big {
    font-size: 60px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    line-height: 102px;
    color: rgba(255, 255, 255, 1);
  }
  .small {
    font-size: 40px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 60px;
    color: rgba(204, 204, 204, 1);
    margin: 64px 0;
  }
  .con {
    animation-delay: 1s;
    width: 60%;
    font-size: 20px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 34px;
    color: rgba(204, 204, 204, 1);
    margin: auto;
  }
}
</style>
